import { Routes } from "@angular/router";
import { HomeComponent } from "./home/home.component";
import { CounterComponent } from "./counter/counter.component";
import { FetchDataComponent } from "./fetch-data/fetch-data.component";
import { AllCoursesResolver } from "./resolvers/allcourses.resolver";
import { CourseDetailsComponent } from "./course-details/course-details.component";
import { CourseResolver } from "./resolvers/course.resolver";
import { CartDetailsComponent } from "./cart-details/cart-details.component";
import { AddedCoursesResolver } from "./resolvers/addedCourses.resolver";
import { WorkShopsComponent } from "./work-shops/work-shops.component";
import { RegistrationComponent } from "./registration/registration.component";
import { TeamComponent } from "./team/team.component";
import { AboutUsComponent } from "./about-us/about-us.component";
import { ContactUsComponent } from "./contact-us/contact-us.component";
import { CourseDetailsWrapperComponent } from "./course-details-wrapper/course-details-wrapper.component";

export const routes: Routes = [
        {
            path: '',
            redirectTo: 'home',
            pathMatch: 'full' 
        },
        { 
            path: 'home', 
            component: HomeComponent, 
            resolve: {
                allCourses: AllCoursesResolver
            },
        },
        { 
            path: 'course/:id', 
            component: CourseDetailsWrapperComponent,
            resolve: {
                course: CourseResolver
            }
        },
        { 
            path: 'cart-details', 
            component: CartDetailsComponent,
            resolve: {
                courses: AddedCoursesResolver
            },
        },
        { 
            path: 'workshops', 
            component: WorkShopsComponent,
            resolve: {
                allCourses: AllCoursesResolver
            },
        },
        { 
            path: 'registration', 
            component: RegistrationComponent,
            resolve: {
                courses: AddedCoursesResolver
            },
        },
        { 
            path: 'team', 
            component: TeamComponent
        },
        { 
            path: 'about-us', 
            component: AboutUsComponent
        },
        { 
            path: 'contact-us', 
            component: ContactUsComponent
        },
];


// WEBPACK FOOTER //
// ./src/app/routes.ts